import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=2ffc1fd5&scoped=true&"
import script from "./AppToolbar.vue?vue&type=script&lang=js&"
export * from "./AppToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc1fd5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/core/AppToolbar.vue
// module id = 168
// module chunks = 32